/**
 * PRNTS Notebook Customizer
 * Live preview met echte productfoto's, kleur, bindwijze en custom tekst (2 regels)
 */

(function() {
  'use strict';

  const NotebookCustomizer = {
    currentColor: '#9B59B6',
    currentColorLabel: 'Paars',
    currentBinding: 'ringband',
    currentBindingLabel: 'Ringband',
    currentText1: 'Mijn Notitieboek',
    currentText2: '',
    currentFont: "'Bebas Neue', sans-serif",
    currentFontLabel: 'Bebas Neue',
    variantMap: {},
    imageMap: {},
    colorAvailability: {},
    elements: {},

    init() {
      const container = document.querySelector('[data-notebook-customizer]');
      if (!container) return;

      // Load variant matrix
      try {
        const mapEl = document.querySelector('[data-notebook-variant-map]');
        if (mapEl) this.variantMap = JSON.parse(mapEl.textContent);
      } catch (e) {
        // Variant map parse failed - customizer won't work
      }

      // Load image map
      try {
        const imgEl = document.querySelector('[data-notebook-image-map]');
        if (imgEl) this.imageMap = JSON.parse(imgEl.textContent);
      } catch (e) {
        // Image map parse failed
      }

      // Load color availability
      try {
        const availEl = document.querySelector('[data-notebook-color-availability]');
        if (availEl) this.colorAvailability = JSON.parse(availEl.textContent);
      } catch (e) {
        // Color availability parse failed
      }

      this.cacheElements(container);
      this.initializeDefaults();
      this.bindEvents();
      this.updateVariant();
      this.updateColorAvailability();
    },

    cacheElements(container) {
      this.elements = {
        container,
        previewContainer: container.querySelector('[data-notebook-preview]'),
        image: container.querySelector('[data-notebook-image]'),
        textOverlay: container.querySelector('[data-notebook-text-overlay]'),
        titleDisplay1: container.querySelector('[data-notebook-title-1]'),
        titleDisplay2: container.querySelector('[data-notebook-title-2]'),
        textInput1: container.querySelector('[data-notebook-text-input-1]'),
        textInput2: container.querySelector('[data-notebook-text-input-2]'),
        colorButtons: container.querySelectorAll('[data-color]'),
        fontButtons: container.querySelectorAll('[data-font]'),
        bindingButtons: container.querySelectorAll('[data-binding]'),
        form: container.querySelector('[data-notebook-form]'),
        variantInput: container.querySelector('[data-notebook-variant-id]'),
        textValueInput1: container.querySelector('[data-notebook-text-value-1]'),
        textValueInput2: container.querySelector('[data-notebook-text-value-2]'),
        colorValueInput: container.querySelector('[data-notebook-color-value]'),
        bindingValueInput: container.querySelector('[data-notebook-binding-value]'),
        fontValueInput: container.querySelector('[data-notebook-font-value]'),
        customizationJson: container.querySelector('[data-notebook-customization-json]'),
        priceDisplay: container.querySelector('[data-notebook-price-display]'),
        submitBtn: container.querySelector('[data-notebook-add-to-cart]')
      };
    },

    initializeDefaults() {
      const selectedColor = this.elements.container.querySelector('.notebook-customizer__color.is-selected');
      if (selectedColor) {
        this.currentColor = selectedColor.dataset.color;
        this.currentColorLabel = selectedColor.dataset.label;
      }

      const selectedBinding = this.elements.container.querySelector('.notebook-customizer__binding.is-selected');
      if (selectedBinding) {
        this.currentBinding = selectedBinding.dataset.binding;
        this.currentBindingLabel = selectedBinding.dataset.label;
      }

      if (this.elements.textInput1) {
        this.currentText1 = this.elements.textInput1.value || 'Mijn Notitieboek';
      }
      if (this.elements.textInput2) {
        this.currentText2 = this.elements.textInput2.value || '';
      }
    },

    bindEvents() {
      // Text input 1 — live preview update
      if (this.elements.textInput1) {
        this.elements.textInput1.addEventListener('input', (e) => {
          this.currentText1 = e.target.value;
          this.updateTextOverlay();
          this.updateFormInputs();
        });
      }

      // Text input 2 — live preview update
      if (this.elements.textInput2) {
        this.elements.textInput2.addEventListener('input', (e) => {
          this.currentText2 = e.target.value;
          this.updateTextOverlay();
          this.updateFormInputs();
        });
      }

      // Color buttons
      this.elements.colorButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-unavailable')) return;

          this.elements.colorButtons.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          this.currentColor = btn.dataset.color;
          this.currentColorLabel = btn.dataset.label;

          this.updateImage();
          this.updateVariant();
          this.updateFormInputs();
        });
      });

      // Font buttons
      this.elements.fontButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.elements.fontButtons.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          this.currentFont = btn.dataset.font;
          this.currentFontLabel = btn.dataset.label;

          this.updateFontOverlay();
          this.updateFormInputs();
        });
      });

      // Binding buttons
      this.elements.bindingButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.elements.bindingButtons.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          this.currentBinding = btn.dataset.binding;
          this.currentBindingLabel = btn.dataset.label;

          // Update binding data attribute for CSS text positioning
          if (this.elements.previewContainer) {
            this.elements.previewContainer.dataset.binding = this.currentBinding;
          }

          this.updateColorAvailability();
          this.updateImage();
          this.updateVariant();
          this.updateFormInputs();
        });
      });

      // Form submit
      if (this.elements.form) {
        this.elements.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }
    },

    updateImage() {
      const key = `${this.currentColorLabel}__${this.currentBinding}`;
      const imageUrl = this.imageMap[key];

      if (imageUrl && this.elements.image) {
        // Cross-fade: dim, swap, brighten
        this.elements.image.classList.add('is-loading');

        const img = new Image();
        img.onload = () => {
          this.elements.image.src = imageUrl;
          // Small delay for the fade effect
          requestAnimationFrame(() => {
            this.elements.image.classList.remove('is-loading');
          });
        };
        img.onerror = () => {
          this.elements.image.classList.remove('is-loading');
        };
        img.src = imageUrl;
      }
    },

    updateTextOverlay() {
      if (this.elements.titleDisplay1) {
        this.elements.titleDisplay1.textContent = this.currentText1 || '';
      }
      if (this.elements.titleDisplay2) {
        this.elements.titleDisplay2.textContent = this.currentText2 || '';
      }
    },

    updateFontOverlay() {
      if (this.elements.textOverlay) {
        this.elements.textOverlay.style.fontFamily = this.currentFont;
      }
    },

    updateColorAvailability() {
      this.elements.colorButtons.forEach(btn => {
        const colorLabel = btn.dataset.label;
        const key = `${colorLabel}__${this.currentBinding}`;
        const available = this.colorAvailability[key];

        if (available) {
          btn.classList.remove('is-unavailable');
        } else {
          btn.classList.add('is-unavailable');

          // Als de huidige kleur niet meer beschikbaar is, switch naar de eerste beschikbare
          if (colorLabel === this.currentColorLabel) {
            this.selectFirstAvailableColor();
          }
        }
      });
    },

    selectFirstAvailableColor() {
      for (const btn of this.elements.colorButtons) {
        const colorLabel = btn.dataset.label;
        const key = `${colorLabel}__${this.currentBinding}`;
        if (this.colorAvailability[key]) {
          this.elements.colorButtons.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this.currentColor = btn.dataset.color;
          this.currentColorLabel = btn.dataset.label;
          return;
        }
      }
    },

    updateVariant() {
      const key = `${this.currentColorLabel}__${this.currentBinding}`;
      const variant = this.variantMap[key];

      if (variant) {
        if (this.elements.variantInput) {
          this.elements.variantInput.value = variant.id;
        }
        if (this.elements.priceDisplay) {
          this.elements.priceDisplay.textContent = variant.price;
        }
      }
    },

    updateFormInputs() {
      if (this.elements.textValueInput1) {
        this.elements.textValueInput1.value = this.currentText1;
      }
      if (this.elements.textValueInput2) {
        this.elements.textValueInput2.value = this.currentText2;
      }
      if (this.elements.colorValueInput) {
        this.elements.colorValueInput.value = this.currentColorLabel;
      }
      if (this.elements.bindingValueInput) {
        this.elements.bindingValueInput.value = this.currentBindingLabel;
      }

      if (this.elements.fontValueInput) {
        this.elements.fontValueInput.value = this.currentFontLabel;
      }

      if (this.elements.customizationJson) {
        this.elements.customizationJson.value = JSON.stringify({
          text1: this.currentText1,
          text2: this.currentText2,
          color: this.currentColor,
          colorLabel: this.currentColorLabel,
          binding: this.currentBinding,
          bindingLabel: this.currentBindingLabel,
          font: this.currentFont,
          fontLabel: this.currentFontLabel,
          timestamp: new Date().toISOString()
        });
      }
    },

    async handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (window.Shopify && window.Shopify.designMode) {
        this.showError('Winkelwagen werkt niet in de Theme Editor.');
        return;
      }

      if (!this.currentText1 || !this.currentText1.trim()) {
        this.showError('Vul minimaal regel 1 in voor op de cover.');
        return;
      }

      this.updateFormInputs();

      const variantId = parseInt(this.elements.variantInput?.value, 10);
      if (!variantId || isNaN(variantId)) {
        this.showError('Selecteer een kleur en bindwijze.');
        return;
      }

      const fullText = this.currentText2
        ? `${this.currentText1} / ${this.currentText2}`
        : this.currentText1;

      const properties = {
        'Tekst regel 1': this.currentText1,
        'Tekst regel 2': this.currentText2 || '-',
        'Kleur': this.currentColorLabel,
        'Bindwijze': this.currentBindingLabel,
        '_customization_data': JSON.stringify({
          text1: this.currentText1,
          text2: this.currentText2,
          color: this.currentColor,
          colorLabel: this.currentColorLabel,
          binding: this.currentBinding,
          bindingLabel: this.currentBindingLabel,
          timestamp: new Date().toISOString()
        })
      };

      const submitBtn = this.elements.submitBtn;
      const originalHTML = submitBtn?.innerHTML;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>Toevoegen...</span>';
      }

      try {
        const cartAddUrl = window.PRNTS?.routes?.cart_add || '/cart/add.js';
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: properties
            }]
          }),
          credentials: 'same-origin'
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || `HTTP ${response.status}`);
        }

        this.updateCartCount();
        this.openCartDrawer();
        this.showSuccess('Notitieboek toegevoegd aan winkelwagen!');

      } catch (error) {
        // Add to cart failed
        this.showError('Kon niet toevoegen aan winkelwagen. Probeer het opnieuw.');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
      }
    },

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin' });
        if (response.ok) {
          const cart = await response.json();
          const countElements = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');
          countElements.forEach(el => {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.removeAttribute('hidden');
          });
        }
      } catch (e) {
        // Non-critical
      }
    },

    openCartDrawer() {
      const drawer = document.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('is-open', 'active');
          document.body.classList.add('cart-drawer-open');
        }
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    },

    showError(message) {
      let errorEl = this.elements.container.querySelector('.notebook-customizer__error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'notebook-customizer__error';
        this.elements.form?.parentNode.insertBefore(errorEl, this.elements.form);
      }
      errorEl.textContent = message;
      errorEl.classList.add('is-visible');
      setTimeout(() => errorEl.classList.remove('is-visible'), 4000);
    },

    showSuccess(message) {
      let toast = document.querySelector('.notebook-customizer__toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'notebook-customizer__toast';
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.add('is-visible');
      setTimeout(() => toast.classList.remove('is-visible'), 3000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => NotebookCustomizer.init());
  } else {
    NotebookCustomizer.init();
  }
})();
